import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";
import { NewsTab } from "core/http/service/news/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: NewsTab[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getNewsTabsSlice = createSlice({
  name: "getNewsTabs",
  initialState,
  reducers: {
    getNewsTabsStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getNewsTabsSuccess: (state, action: PayloadAction<NewsTab[]>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getNewsTabsFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetNewsTabs: () => {
      return { ...initialState };
    },
  },
});

export const {
  getNewsTabsStart,
  getNewsTabsSuccess,
  getNewsTabsFailed,
  resetNewsTabs,
} = getNewsTabsSlice.actions;

export default getNewsTabsSlice.reducer;
